const Element = ({ url }) => {
  return <video width="800" height="500" src={url} controls />
}

export default Element
